import { connect } from 'react-redux';
import CheckDocuments from './CheckDocuments';
import { contractsBySubscriptionProductSerialNumberSelector } from '../../modules/LegalDocuments/Contracts/selectors';
import { agreementsBySubscriptionProductSerialNumberSelector } from '../../modules/Agreements/selectors';
import { tokenSelector } from '../../modules/Authentication';

const mapStateToProps = (state, ownProps) => ({
  agreements: agreementsBySubscriptionProductSerialNumberSelector(
    state,
    ownProps.route.params?.subscriptionSerialNumber
  ),
  contracts: contractsBySubscriptionProductSerialNumberSelector(state, ownProps.route.params?.subscriptionSerialNumber),
  token: tokenSelector(state),
});

export default connect(mapStateToProps)(CheckDocuments);
